import React from 'react'

// Tail-word count to keep at bold (medium) weight while the rest of the
// heading is lightened to regular — e.g. 6-word heading bolds the last 3,
// a 4-word heading bolds the last 2, a 3-word heading bolds the last 1,
// a 2-word heading bolds only the last word. Caps at 3 for longer headings.
export function getBoldTailCount(wordCount) {
  if (wordCount > 5) return 3
  return Math.floor(wordCount / 2)
}

export function BoldTailHeading({ text }) {
  if (!text) return null

  const words = text.trim().split(/\s+/)
  const boldCount = getBoldTailCount(words.length)

  if (!boldCount || boldCount >= words.length) {
    return text
  }

  const regular = words.slice(0, words.length - boldCount).join(' ')
  const bold = words.slice(words.length - boldCount).join(' ')

  return (
    <>
      <span style={{ fontWeight: 400 }}>{regular} </span>
      <span style={{ fontWeight: 500 }}>{bold}</span>
    </>
  )
}
